// extracted by mini-css-extract-plugin
export default {"boton":"UsuarioCrearScreen_boton__VWojL"};